<template lang="pug">
	div(class="resume-wide resume-vertical-scroll" style="border:none;")
			div(@click="m_editMode")
				div(class="section-title")
					<strong class="primary">🎓Education</strong><sup title="Toggle Edit" variant="outline-primary" style="border:none;"><fa-icon icon="pencil-alt" /></sup>
			div(v-if="d_editMode")
				b-table(id="education" ref="education" :fields="d_educationFields" :items="d_education" class="font-weight-bold" style="font-size: 12px;" sticky-header="2000px"
					small striped responsive borderless hover selectable 	select-mode="single" 	selected-variant="success" 	show-empty 	tbody-tr-class="rowStyle" 
					@row-clicked="m_clicked" @row-dblclicked="m_dblClicked('education', $event)"
					)
					<!-- Degree column -->
					<template v-slot:cell(degree)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.degree }}</div>
						<b-form-input v-else v-model="data.item.degree"   size="sm"  />
					</template>
					<!-- field column -->
					<template v-slot:cell(field)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.field }}</div>
						<b-form-input v-else v-model="data.item.field"   size="sm"  />
					</template>
					<template v-slot:cell(school)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.school }}</div>
						<b-form-input v-else v-model="data.item.school"   size="sm"  />
					</template>
					<template v-slot:cell(year)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.year }}</div>
						<b-form-input v-else v-model="data.item.year"   size="sm"  />
					</template>
					template(#empty="scope")
						span No Educational qualifications!!
				div(v-if="d_copyPaste")
					<vue-editor ref="editor" v-model="d_copyPasteData" :editorToolbar="d_editorModules" @ready="m_onEditorReady"  :placeholder="d_placeholder"></vue-editor>
			div(v-else)
				div(v-if="d_education.length>0")
					div( v-for="e in d_education" :key="e.degree+e.school" )
						<span v-html="m_getEducation(e)"></span>
				span(v-else) No Educational qualifications!!

</template>
<script>
import {VueEditor} from "vue2-editor";
export default {
  name: "resumeEducation",
  components: { VueEditor },

  props: {
    value: Array,        // <-- parent passes an array
    p_editMode: Boolean
  },

  data() {
    return {
      d_editMode: this.p_editMode,
      d_education: [],   // local copy of the array
	  d_educationFields:[{key:"degree",field:"degree",title:"Degree",type:"input", datatype:"text",required:true,thStyle: { width: '80px' }, tdStyle: { width: '80px' }},
						{key:"field",field:"field",title:"Field",type:"input", datatype:"text",required:true},
						{key:"school",field:"school",title:"School",type:"input", datatype:"text"},
						{key:"year",field:"year",title:"Year",type:"input", datatype:"text",thStyle: { width: '80px' }, tdStyle: { width: '80px' }},
						],
      d_newRecord: { degree:null, field:null, school:null, year:null },
      d_selectedIndex: null,
      d_copyPaste: false,
      d_copyPasteData: "",
      d_editorModules: [
        ['bold', 'italic', 'underline'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['clean'], ['upload']
      ],
      quill: null,
      d_placeholder: "Format:Degree,Field,School,Year"
    }
  },

  created() {this.d_education = (this.value || []).map(row => ({ ...row }));},
  mounted() {
    // value is an array, so clone it
	console.log('In resumeEducation mounted');
	console.log(this.value);
	//this.d_education.length=0;
    
  },

watch: {
  p_editMode(newVal) {
    this.d_editMode = newVal;
  },
  value: {
  immediate: true,
  deep: true,
  handler(newVal) {
    if (!newVal) return
	this.d_resumeData = newVal.resumeData;
    this.d_education = newVal.map(row => ({ ...row }))
  }
}

  },
  

  methods: {
	m_editMode() {
		this.d_editMode = !this.d_editMode;
		if(this.d_editMode) this.$emit("activate", "education");
		if(!this.d_editMode) this.d_copyPaste=false;
	},
	m_copyPaste(){this.d_copyPaste=!this.d_copyPaste;},
    m_addRecord() {
      this.d_education.push({ ...this.d_newRecord })
	  //this.d_education.push(JSON.parse(JSON.stringify(this.d_newRecord)));
      this.d_editMode = true
      this.d_selectedIndex = this.d_education.length - 1
    },

    m_clicked(row, index) {
      this.d_selectedIndex = index
    },

    m_dblClicked() {
      if (this.d_selectedIndex == null) return
      this.d_editMode = true
    },

    m_toggleEditMode() {
      this.d_editMode = !this.d_editMode
    },

    m_save() {
      // Emit only the array
      this.$emit("input", this.d_education)
    },


    m_undo() {
		this.d_education.length=0;
		this.d_education = (this.value || []).map(row => ({ ...row }))
    },

    m_deleteRecord() {
      if (this.d_selectedIndex == null) return
      const temp = [...this.d_education]
      temp.splice(this.d_selectedIndex, 1)
      this.d_education = temp
    },

    m_processCopyPaste() {
      const text = this.quill.getText()

      const pastedRows = text
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(line => line.length)
        .map(line => line.split(","))

      pastedRows.forEach(r => {
        this.d_education.push({
          degree: r[0],
          field: r[1],
          school: r[2],
          year: r[3]
        })
      })
    },
	
	m_getEducation(data) {
		var rowData=null;
		if(data.degree) rowData=`<span style="color:green;">${data.degree}</span>`;
		if(data.field) rowData=rowData+" "+`<span style="color:#007bff;">${data.field}</span>`;
		if(data.school) rowData = rowData+","+data.school;
		if(data.year) rowData = rowData+" "+ data.year;
		return rowData;
		},

    m_onEditorReady(editorInstance) {
      this.quill = editorInstance

      const toolbarEl = this.quill.container.parentNode.querySelector('.ql-toolbar')

      if (toolbarEl) {
        const customBtn = document.createElement('button')
        customBtn.className = 'ql-custom-upload'
        customBtn.title = "Upload"
        customBtn.appendChild(document.createTextNode("📤"))
        customBtn.addEventListener('click', this.m_processCopyPaste)
        toolbarEl.appendChild(customBtn)
      }
    }
  }
}
</script>
<style scoped>
.cv-container {
  max-width: 900px;
  margin: auto;
}
section {
  margin-bottom: 2rem;
}
.section-header {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
}

.timeline {
  position: relative;
  list-style: none;
  padding-left: 30px;
  margin-top: 1rem;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #ddd;
}

.timeline-item {
  position: relative;
  margin-bottom: 2rem;
  cursor: grab;
}

.dot {
  position: absolute;
  left: 4px;
  top: 18px;
  width: 16px;
  height: 16px;
  background: #2c7be5;
  border-radius: 50%;
}

.card {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 1rem;
  margin-left: 20px;
}

input,
textarea {
  width: 100%;
  margin-bottom: 0.5rem;
}

.row {
  display: flex;
  gap: 0.5rem;
}

button {
  cursor: pointer;
}

.debug {
  background: #f7f7f7;
  padding: 1rem;
  font-size: 0.8rem;
}
.header-btn {
  display: flex;
  align-items: center;
  gap: 6px;
}
.header-btn .emoji {
  font-size: 1.2rem;
  cursor: pointer;
}
.emoji {
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s ease;
}

.emoji:hover {
  background: #f0f0f0;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒";     /* "🡒" */
  color: #1E90FF; 
}
details[open] summary::before { 
  content:"🠣";  /* "🠣""🡑"*/ 
  color: #1E90FF; 
}
.btn-add {
	text-align: right;
	border:none;
	}
.btn-delete {
	color: #dc3545;
	text-align: right;
	border:none;
	}
.btn-undo {
	border:none;
	}
.btn-expand {
	color: #FFA500;
	border:none;
	}
.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 5px;
  padding-bottom: 4px;
  border-bottom: 2px solid #ccc;
  letter-spacing: 0.5px;
}
.section-accent {
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 2rem;
  padding-left: 10px;
  border-left: 4px solid #4a6fa5; /* pick your accent color */
}
.btn-outline-primary,
.btn-outline-danger,
.btn-outline-warning,
.btn-outline-secondary {
   border:none;
   border-color:white;
}
.resume-wide {
  width: 100%;
  min-width: 1200px; /* or whatever your tables need */
  position: relative;
  z-index: 10;
  overflow-x: auto;
  overflow-y: auto;
}
.col-4 {
  overflow: visible !important;
}
.resume-flex-expand {
  flex: 1 1 100%;
  max-width: 100%;
}
.resume-wide textarea {
  border: 1px solid #ccc;
  padding: 12px;
  font-size: 14px;
  line-height: 1.4;
}
.resume-vertical-scroll {
  max-height: 4000px;   /* adjust to your needs */
  overflow-y: auto;
  overflow-x: hidden;  /* optional, keeps it tidy */
  border: none;
  border-radius: 4px;
  background: #fff;
}
.ql-toolbar .ql-custom-upload {
  margin-left: 8px;
  padding: 4px 10px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}
.section-title {
    font-size: 15px;
    font-weight: 700;
    text-transform1: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 4px;
    margin-bottom: 12px;
  }
 
}



/style>

/*
    this.d_quill = editorInstance;

    // Get the Quill constructor
    const Quill = this.d_quill.constructor;

// Register a no-op format so Quill recognizes "upload"
  const Parchment = Quill.import('parchment');
  const UploadFormat = new Parchment.Attributor('upload', 'upload', {});
  Quill.register(UploadFormat, true);


    // Add icon
    const icons = Quill.import('ui/icons');
    icons['upload'] = '<i class="fa fa-upload"></i>';

    // Add handler
    const toolbar = this.d_quill.getModule('toolbar');
    toolbar.addHandler('upload', this.m_processCopyPaste);
 */
  
